$(function () {
    const stepSwiper = new Swiper(".stepSwiper", {
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        }
    });
});

//# sourceMappingURL=career.js.map
